import { createSelector } from 'reselect';
import getOptinState from './getOptinState';
import { RootState } from '../../../stores/types';
import { OptinPromptState, OptinState } from '../types';

export default createSelector<RootState, OptinState, OptinPromptState>(
  getOptinState,
  (optinState: OptinState) => optinState.entities.prompts,
);
